// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Companies_establishments__1crFE","header":"Companies_header__1-gSO","tableHeader":"Companies_tableHeader__2i5j2"};